import React  from "react"
import styled from 'styled-components';
import parse from 'html-react-parser'
import {GatsbyImage} from 'gatsby-plugin-image'
import ButtonForm from './ButtonForm';
import {CgClose} from 'react-icons/cg'
import { StaticQuery, graphql } from "gatsby"

const ContactForm = styled.div`
opacity:${props => props.showModal === false ? "0" : "1"};
pointer-events:${props => props.showModal === false ? 'none' : 'all'};


  .centered{
  opacity:${props => props.showModal === false ? "0" : "1"};
  transform:${props => props.showModal === false ? "translateY(200px)" : "translateY(0px)"};

    .right{
      form{
        .phone,
        .name{
        margin-right:2rem;
        }

        .message{
        width:100% !important;
        }
      }

    }

  }

  form{
    pointer-events:${props => props.showModal === false ? "none" : "all"};;;
  }

`

class ContactModal extends React.Component {
  state = {
    modal: this.props.isActive,
  }

  constructor(props) {
    super(props);
    this.contactForm = React.createRef();
  }

  
  componentDidMount(){
    const isClient = typeof document !== 'undefined' && typeof window !== 'undefined';
    let header
    
    if(isClient){
      header = document.querySelector('#header');
      header.parentNode.after(this.contactForm.current);
      window.addEventListener('resize', this.setOverflowOnModal);
    }
    
   this.setOverflowOnModal();
    
  }

  componentDidUpdate(){
    this.setOverflowOnModal();
  }

  componentWillUnmount(){
    const isClient = typeof document !== 'undefined' && typeof window !== 'undefined';
   
    if(isClient){
      window.removeEventListener('resize', this.setOverflowOnModal)
    }
  }

  setOverflowOnModal = () => {
    const outerH = this.contactForm.current.offsetHeight;
    const innerH = this.contactForm.current.querySelector('.centered .right').offsetHeight;

    if(innerH > outerH){
      this.contactForm.current.classList.add('overflow-required');
    }else{
      this.contactForm.current.classList.remove('overflow-required');
    }
    
  }

  
  toggleLoginModalAndControl = () => {
    this.props.toggleLoginModal();
    this.props.toggleIsLoggedIn();
  }

  toggleModal = () => {
    this.props.toggleLoginModal();    
  }
  render() {

    // if (isLoggedIn()) {
    //   navigate(`/app/profile`)
    // }
    
    

    return (
      <StaticQuery
          query={graphql`
            query ContactModalQuery {
                wp {
                    options {
                      acf_options {
                        contactText
                        contactHeading
                        contactImage {
                          localFile{
                            childImageSharp {
                              gatsbyImageData
                            }
                          }
                        }
                      }
                    }
                }
            }
          `}
          render={data => (
            <ContactForm className="contactModal modal" ref={this.contactForm} showModal={this.props.isActive}>
              <div className="centered">
                <div className="left">
                  <GatsbyImage image={data.wp.options.acf_options.contactImage.localFile.childImageSharp.gatsbyImageData} />
                </div>
                <div className="right">
                  <button aria-label="Close Popup" className="close" onClick={this.toggleModal}><CgClose /></button>
                  <h1 className="heading--l">{parse(data.wp.options.acf_options.contactHeading)}</h1>
                  <div className="text">{parse(data.wp.options.acf_options.contactText)}</div>
                  <form action="https://getform.io/f/0a2d72fd-fa7d-43b0-9ca7-8abf591c6921" method="POST">
                    <div className="name">
                      <span>Name</span>
                      <input
                        type="text"
                        name="name"
                        required
                      />
                    </div>
                    <div className="email">
                      <span>Email</span>
                      <input type="text" name="email"  required/>
                    </div>
                    <div className="phone">
                      <span>Phone</span>
                      <input
                        type="text"
                        name="phone"
                        required
                      />
                    </div>
                    <div className="business">
                      <span>Business Name</span>
                      <input
                        type="text"
                        name="business"
                      />
                    </div>
                    <div className="message">
                      <span>Message</span>
                      <textarea rows="5" type="text" name="message"/>
                    </div>
                    <div className="button-wrap">
                      <ButtonForm 
                        buttonBgColor={'white'}
                        buttonBgColorHover={'brandColor'}
                        buttonTextColor={'black'}
                        buttonTextColorHover={'black'}
                        buttonBorderColor={'black'}
                        text="Submit"
                        />
                      </div>
                  </form>
                </div>
              </div>
            </ContactForm>
          )}
        />
    )
  }
}

export default ContactModal
